<script setup lang="ts">
import { onMounted, onBeforeMount } from "vue";

import { useOpenIdAuthenticationStore } from "@/stores/AppStartUp/OpenIdAuthenticationStore";
import { useAuthUserStore } from "@/stores/AppStartUp/AuthUserStore";
import GlobalLoadingScreen from "@/components/GlobalLoadingScreen.vue";
import { useGlobalLoadingStore } from "@/stores/AppStartUp/GlobalLoadingStore";
import { useRouter } from "vue-router";
import { ROUTE } from "@/router/routeDefinitions";
import { useRoutePermission } from "@/composable/useRoutePermission";
import { useLoginHistoryStore } from "@/stores/AppStartUp/LoginHistoryStore";
import { useInitializeKlaro } from "@/composable/useInitializeKlaro";
import { useGTM } from "@/composable/useGTM";

const openIdAuthenticationStore = useOpenIdAuthenticationStore();
const authUserStore = useAuthUserStore();
const globalLoadingStore = useGlobalLoadingStore();
const router = useRouter();
const { initialize } = useRoutePermission();
const loginHistoryStore = useLoginHistoryStore();
const initKlaro = useInitializeKlaro();
const gtm = useGTM();

onBeforeMount(() => {
    gtm.setup();
});

onMounted(async () => {
    initKlaro.setup();
    globalLoadingStore.showLoadingScreen();

    try {
        await loginHistoryStore.initialize();
        await openIdAuthenticationStore.initialize();
        await authUserStore.initialize();
        await router.isReady();
        await initialize();
    } catch (error) {
        console.error("App: Initialization failed", error);
        await router.push({ name: ROUTE.PUBLIC_ERROR_PAGE.NAME });
    } finally {
        globalLoadingStore.hideLoadingScreen();
    }
});
</script>

<template>
    <GlobalLoadingScreen />
    <v-app>
        <router-view />
    </v-app>
</template>
